import { connect } from "react-redux";

import VolumenUndLeckage from "./VolumenUndLeckage";

import { compressorIsInstalled } from "../model/Kompressor";

const format_think_green_to_leckage_und_volumen = (think_green, units, compressors) => {
	if (think_green.compressors === undefined)
		return [];

	let c_filtered = think_green.compressors.filter((c, i) => compressorIsInstalled(compressors[i]));
	let comp_ready = c_filtered.map(
		c => {
			let energy = c.energy_offload + c.energy_onload;
			return Object.assign(
				{
					energy
				}, c);
		}
	);
	let s = comp_ready.reduce((acc, curr) => {
		acc.energy += curr.energy;
		acc.total_volume += curr.total_volume;
		acc.leaked_volume += curr.leaked_volume;
		return acc;
	}, {cindex: -1, energy: 0, total_volume: 0, leaked_volume:0});
	return [s].concat(comp_ready).map(
		c => {
			let volume_cost = c.energy * units.electricity_rate;
			let volume_cost_per_unit = c.total_volume !== 0 ? volume_cost / c.total_volume : 0;
			let leakage_cost = c.leaked_volume * volume_cost_per_unit;
			let leakage_co2_equivalent = c.total_volume !== 0 ? (c.leaked_volume / c.total_volume) * c.energy * units.electricity_co2_equivalent : 0;
			return Object.assign(
				{
					volume_cost,
					volume_cost_per_unit,
					leakage_cost,
					leakage_co2_equivalent
				}, c);
		}
	);
};

export default connect(state => {
	let leckage_und_volumen = format_think_green_to_leckage_und_volumen(state.ablauf.statistics.think_green, state.settings.units, state.ablauf.compressors);
	return {
		leckage_und_volumen,
		compressors: state.ablauf.compressors,
		units: state.units
	};
})(VolumenUndLeckage);
